module.exports = __webpack_public_path__ + "static/img/home-3.b90e1ce7.png";